import { render, staticRenderFns } from "./FeaturesSplit.vue?vue&type=template&id=60ff1617&scoped=true&"
import script from "./FeaturesSplit.vue?vue&type=script&lang=js&"
export * from "./FeaturesSplit.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesSplit.vue?vue&type=style&index=0&id=60ff1617&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff1617",
  null
  
)

export default component.exports